import AppHelper from "../../helpers/appHelper";
import axios from "axios";
import ActionCreator, { pingEventService } from "../../helpers/apiRequestor";
import {
  SAVE_BANK_ACCOUNTS,
  CONTACT_PREFERENCES_ENDPOINT,
} from "../../helpers/apiUrls";
import {HttpType
} from "../../helpers/constantValues";
import {
  GET_ACCOUNT_ALERTS_PENDING,
  GET_ACCOUNT_ALERTS_FULFILLED,
  GET_ACCOUNT_ALERTS_FAILED, UPDATE_ALERT_BANKING_PENDING,
  UPDATE_ALERT_BANKING_FULFILLED,
  UPDATE_ALERT_BANKING_FAILED,
  BANKING_ALERTS_FULFILLED,
  BANKING_ALERTS_PENDING,
  BANKING_ALERTS_ERROR
} from "../actionTypes";

export const manageTextBanking = () => {
  pingEventService();
  return (dispatch) => dispatch(ActionCreator(
    {
      url: AppHelper.getMiddlewareApiUrl(CONTACT_PREFERENCES_ENDPOINT),
      method: HttpType.GET,
      headers: {
      }
    },
    GET_ACCOUNT_ALERTS_PENDING,
    GET_ACCOUNT_ALERTS_FULFILLED,
    GET_ACCOUNT_ALERTS_FAILED,
    BANKING_ALERTS_FULFILLED,
    BANKING_ALERTS_PENDING,
    BANKING_ALERTS_ERROR
  ));
};

export const saveAccounts = (account) => (dispatch) => {
  dispatch({ type: UPDATE_ALERT_BANKING_PENDING });
  pingEventService();
  axios({
     url: AppHelper.getMiddlewareApiUrl(SAVE_BANK_ACCOUNTS + account.accountNumber),
    method: HttpType.POST,
    data: account,
    headers: {
      ...AppHelper.getSessionTokenHeaders()
    },

  }).then(response => {
    dispatch({ type: UPDATE_ALERT_BANKING_FULFILLED, data: response.data, accountNumber: account.accountNumber });
  })
    .catch(() => {
      dispatch({ type: UPDATE_ALERT_BANKING_FAILED });
    });
}
